import React from "react";
import { SpinnerContainer, SpinnerRing } from "./__styles__/LoadingSpinner";

export interface LoadingSpinnerProps {
  size?: number;
  color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 16,
  color = "#6B7280",
}) => {
  return (
    <SpinnerContainer
      role="status"
      aria-live="polite"
      aria-label="Loading"
      css={{ width: size, height: size }}
      data-testid="assistant-loading-spinner"
    >
      <SpinnerRing
        css={{ borderColor: `${color}20 ${color}20 ${color}20 ${color}` }}
      />
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
